export default __webpack_public_path__ + "static/media/corpVision.44e66e51.PNG";